import { computed } from "vue";
import { useAuthUserStore } from "../Store/AuthUserStore.js";

/**
 * Guard that allows only admin and back_office users.
 */
export const adminGuard = (to, from, next) => {
    const authUserStore = useAuthUserStore();
    const authUser = computed(() => authUserStore.authUser);

    if (authUser.value.role !== 'admin' && authUser.value.role !== 'back_office') {
        next('/unauthorized');
    } else {
        next();
    }
};

/**
 * Guard that blocks staff and external users.
 */
export const notStaffOrExternalGuard = (to, from, next) => {
    const authUserStore = useAuthUserStore();
    const authUser = computed(() => authUserStore.authUser);

    if (authUser.value.role === 'staff' || authUser.value.role === 'external') {
        next('/unauthorized');
    } else {
        next();
    }
};
